// Single source of truth for the support / forgot-password WhatsApp number.
// Used by the Login screen's "Forgot Password" button and anywhere else that
// needs to deep-link a user into a WhatsApp chat with the platform admin.
//
// Format: digits only, country code prefix INCLUDED (no `+`).
// `wa.me/<digits>` is the canonical click-to-chat URL Meta documents.
export const SUPPORT_WHATSAPP_NUMBER = "918093414633";  // +91 80934 14633

/**
 * Build a wa.me URL with a URL-encoded prefilled message.
 * @param {string} message - Plain-text body to prefill in WhatsApp.
 * @returns {string} A click-to-chat URL.
 */
export function buildSupportWhatsAppUrl(message) {
  const text = encodeURIComponent(message || "");
  return `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${text}`;
}
